import "./ToggleButton.css";

import React from "react";

const ToggleButton = ({ options, onSelect, selected }) => (
  <div>
    {options.map(({ label, option }) => (
      <div
        key={option}
        onClick={() => onSelect(option)}
        className={"toggle " + (selected === option ? "active" : "inactive")}
      >
        {label}
      </div>
    ))}
  </div>
);

export default ToggleButton;
